import React, { useState, useEffect } from 'react';
import { Modal, Button, Upload, App } from 'antd';
import { FilePdfOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';

const PaymentConfirmModal = ({ isOpen, onClose, onConfirm, submitting }) => {
  const { message } = App.useApp();
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedFile(null);
    }
  }, [isOpen]);

  const handleBeforeUpload = (file) => {
    const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
    if (!isPdf) {
      message.error('Solo se permiten archivos en formato PDF (.pdf)');
      return Upload.LIST_IGNORE;
    }
    setSelectedFile(file);
    return false; // Evita la carga automática de AntD
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  const handleConfirmSubmit = () => {
    onConfirm(selectedFile);
  };

  return (
    <Modal
      title={null}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      className="claim-payment-modal"
      width={440}
      centered
      styles={{ 
        content: { 
          backgroundColor: '#0f172a', 
          border: '1px solid #1e293b', 
          borderRadius: '16px',
          padding: '32px 24px'
        } 
      }}
      closeIcon={<span style={{ color: '#94a3b8', fontSize: '16px' }}>✕</span>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <div style={{ 
          width: '64px', 
          height: '64px', 
          borderRadius: '50%', 
          border: '3px solid #eab308', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <span style={{ color: '#eab308', fontSize: '32px', fontWeight: 'bold' }}>?</span>
        </div>
        
        <h2 style={{ color: '#ffffff', fontSize: '20px', fontWeight: 'bold', marginBottom: '12px', lineHeight: '1.3' }}>
          ¿Confirma que el premio ya fue entregado al ganador?
        </h2>
        
        <p style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '24px', lineHeight: '1.5' }}>
          Esta acción actualizará el estado del proceso a "Pago Realizado" y se enviará una notificación al participante.
        </p>

        {/* Sección comprobante PDF opcional */}
        <div style={{ width: '100%', marginBottom: '28px', textAlign: 'left' }}>
          <label style={{ 
            color: '#cbd5e1', 
            fontSize: '13px', 
            fontWeight: 500, 
            display: 'block', 
            marginBottom: '8px' 
          }}>
            Comprobante de pago (PDF) <span style={{ color: '#64748b' }}>(Opcional)</span>
          </label>

          {!selectedFile ? (
            <Upload
              accept=".pdf,application/pdf"
              beforeUpload={handleBeforeUpload}
              showUploadList={false}
              multiple={false}
            >
              <div style={{
                width: '100%',
                padding: '16px',
                border: '1px dashed #334155',
                borderRadius: '8px',
                backgroundColor: 'rgba(15, 23, 42, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                cursor: 'pointer',
                transition: 'border-color 0.2s',
                color: '#94a3b8'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = '#eab308'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = '#334155'}
              >
                <UploadOutlined style={{ fontSize: '18px', color: '#eab308' }} />
                <span style={{ fontSize: '14px', color: '#f8fafc' }}>Seleccionar comprobante PDF</span>
              </div>
            </Upload>
          ) : (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              backgroundColor: 'rgba(234, 179, 8, 0.1)',
              border: '1px solid rgba(234, 179, 8, 0.3)',
              borderRadius: '8px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden', marginRight: '8px' }}>
                <FilePdfOutlined style={{ fontSize: '20px', color: '#ef4444', flexShrink: 0 }} />
                <span style={{ 
                  color: '#f8fafc', 
                  fontSize: '13px', 
                  fontWeight: 500, 
                  whiteSpace: 'nowrap', 
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis' 
                }}>
                  {selectedFile.name}
                </span>
              </div>
              <Button
                type="text"
                icon={<DeleteOutlined style={{ color: '#ef4444' }} />}
                onClick={handleRemoveFile}
                disabled={submitting}
                style={{ padding: '4px' }}
              />
            </div>
          )}
        </div>
        
        <div style={{ display: 'flex', width: '100%', gap: '12px' }}>
          <Button 
            onClick={onClose}
            disabled={submitting}
            style={{ 
              flex: 1, 
              height: '48px', 
              backgroundColor: 'transparent', 
              borderColor: '#334155', 
              color: '#f8fafc',
              borderRadius: '8px',
              fontWeight: 500
            }}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleConfirmSubmit}
            loading={submitting}
            style={{ 
              flex: 1, 
              height: '48px', 
              backgroundColor: '#eab308', 
              borderColor: '#eab308', 
              color: '#000000',
              borderRadius: '8px',
              fontWeight: 600
            }}
          >
            Confirmar Pago
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentConfirmModal;

